import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import BookingModal from './components/BookingModal';

export default function Tours() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [priceRange, setPriceRange] = useState([0, 5000]);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [selectedTour, setSelectedTour] = useState({ name: '', price: '' });

  const categories = ['All', 'Cultural', 'Beach', 'Adventure', 'Wildlife', 'Luxury'];

  const tours = [
    {
      id: 1,
      title: 'European Grand Tour',
      category: 'Cultural',
      image: 'https://public.readdy.ai/ai/img_res/d79b2ef67d49afbb7c8ce5e001740110.jpg',
      duration: '14 Days',
      groupSize: '12-16 People',
      price: 2899,
      description: 'Explore the best of Europe with visits to Paris, Rome, Barcelona, and more. Experience world-class museums, historic landmarks, and authentic local cuisine.',
      highlights: ['Eiffel Tower', 'Colosseum', 'Sagrada Familia', 'Local Food Tours'],
    },
    {
      id: 2,
      title: 'Tropical Paradise Escape',
      category: 'Beach',
      image: 'https://readdy.ai/api/search-image?query=breathtaking%20tropical%20island%20paradise%20with%20pristine%20turquoise%20lagoon%20surrounded%20by%20lush%20green%20palm%20trees%20and%20powdery%20white%20sand%20beach%20under%20brilliant%20blue%20sky%20creating%20idyllic%20vacation%20destination%20travel%20photography&width=800&height=600&seq=tour2&orientation=landscape',
      duration: '7 Days',
      groupSize: '8-12 People',
      price: 1599,
      description: 'Relax on pristine beaches in the Maldives and enjoy luxury resort living with water sports and spa treatments.',
      highlights: ['Private Beach Access', 'Snorkeling', 'Spa Treatments', 'Sunset Cruises'],
    },
    {
      id: 3,
      title: 'Asian Adventure',
      category: 'Adventure',
      image: 'https://readdy.ai/api/search-image?query=stunning%20asian%20temple%20complex%20with%20ornate%20golden%20architecture%20surrounded%20by%20vibrant%20tropical%20gardens%20and%20misty%20mountains%20in%20background%20creating%20mystical%20spiritual%20atmosphere%20perfect%20for%20adventure%20travel%20photography&width=800&height=600&seq=tour3&orientation=landscape',
      duration: '10 Days',
      groupSize: '10-14 People',
      price: 2199,
      description: 'Discover the wonders of Thailand, Vietnam, and Cambodia with ancient temples, bustling markets, and exotic cuisine.',
      highlights: ['Angkor Wat', 'Ha Long Bay', 'Bangkok Markets', 'Cooking Classes'],
    },
    {
      id: 4,
      title: 'African Safari Experience',
      category: 'Wildlife',
      image: 'https://readdy.ai/api/search-image?query=majestic%20african%20savanna%20landscape%20with%20golden%20grasslands%20acacia%20trees%20and%20dramatic%20sunset%20sky%20creating%20stunning%20wildlife%20safari%20atmosphere%20perfect%20for%20adventure%20travel%20photography&width=800&height=600&seq=tour4&orientation=landscape',
      duration: '12 Days',
      groupSize: '8-10 People',
      price: 3499,
      description: 'Witness incredible wildlife in Kenya and Tanzania national parks including the Big Five and the Great Migration.',
      highlights: ['Serengeti Safari', 'Masai Mara', 'Big Five Viewing', 'Luxury Lodges'],
    },
    {
      id: 5,
      title: 'South American Discovery',
      category: 'Cultural',
      image: 'https://readdy.ai/api/search-image?query=spectacular%20south%20american%20mountain%20landscape%20with%20ancient%20ruins%20colorful%20traditional%20architecture%20and%20dramatic%20peaks%20creating%20vibrant%20cultural%20travel%20destination%20photography&width=800&height=600&seq=tour5&orientation=landscape',
      duration: '15 Days',
      groupSize: '12-16 People',
      price: 3299,
      description: 'Journey through Peru, Bolivia, and Argentina exploring ancient cultures, stunning landscapes, and vibrant cities.',
      highlights: ['Machu Picchu', 'Lake Titicaca', 'Buenos Aires', 'Inca Trail'],
    },
    {
      id: 6,
      title: 'Australian Outback',
      category: 'Adventure',
      image: 'https://readdy.ai/api/search-image?query=stunning%20australian%20outback%20landscape%20with%20red%20desert%20rock%20formations%20under%20brilliant%20blue%20sky%20creating%20dramatic%20natural%20adventure%20travel%20photography&width=800&height=600&seq=tour6&orientation=landscape',
      duration: '9 Days',
      groupSize: '10-12 People',
      price: 2799,
      description: 'Experience the rugged beauty of Australia\'s interior and coastal wonders from Sydney to the Great Barrier Reef.',
      highlights: ['Great Barrier Reef', 'Uluru', 'Sydney Opera House', 'Coastal Drives'],
    },
    {
      id: 7,
      title: 'Caribbean Island Hopping',
      category: 'Beach',
      image: 'https://readdy.ai/api/search-image?query=pristine%20caribbean%20beach%20with%20turquoise%20water%20white%20sand%20and%20palm%20trees%20under%20sunny%20sky%20tropical%20paradise%20travel%20photography&width=800&height=600&seq=tour7&orientation=landscape',
      duration: '8 Days',
      groupSize: '10-14 People',
      price: 1899,
      description: 'Sail through the Caribbean visiting multiple islands with crystal-clear waters and vibrant local culture.',
      highlights: ['Island Hopping', 'Sailing', 'Beach BBQ', 'Water Sports'],
    },
    {
      id: 8,
      title: 'Japanese Cultural Journey',
      category: 'Cultural',
      image: 'https://readdy.ai/api/search-image?query=beautiful%20japanese%20temple%20with%20traditional%20architecture%20surrounded%20by%20cherry%20blossoms%20and%20zen%20gardens%20creating%20serene%20cultural%20atmosphere%20travel%20photography&width=800&height=600&seq=tour8&orientation=landscape',
      duration: '11 Days',
      groupSize: '12-15 People',
      price: 3199,
      description: 'Immerse yourself in Japanese culture from Tokyo\'s modern marvels to Kyoto\'s ancient temples and traditions.',
      highlights: ['Tokyo Skyline', 'Kyoto Temples', 'Mt. Fuji', 'Tea Ceremony'],
    },
    {
      id: 9,
      title: 'New Zealand Adventure',
      category: 'Adventure',
      image: 'https://readdy.ai/api/search-image?query=dramatic%20new%20zealand%20mountain%20landscape%20with%20snow%20capped%20peaks%20pristine%20lakes%20and%20lush%20valleys%20creating%20breathtaking%20adventure%20travel%20photography&width=800&height=600&seq=tour9&orientation=landscape',
      duration: '13 Days',
      groupSize: '10-12 People',
      price: 3599,
      description: 'Explore New Zealand\'s stunning landscapes from fjords to glaciers with adventure activities and scenic drives.',
      highlights: ['Milford Sound', 'Queenstown', 'Glacier Hiking', 'Bungee Jumping'],
    },
  ];

  const filteredTours = tours.filter(tour => {
    const categoryMatch = selectedCategory === 'All' || tour.category === selectedCategory;
    const priceMatch = tour.price >= priceRange[0] && tour.price <= priceRange[1];
    return categoryMatch && priceMatch;
  });

  const handleBookNow = (tourName, tourPrice) => {
    setSelectedTour({ name: tourName, price: tourPrice });
    setIsBookingModalOpen(true);
  };

  return (
    <>
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center overflow-hidden mt-20">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=diverse%20collection%20of%20world%20famous%20travel%20destinations%20and%20landmarks%20arranged%20in%20artistic%20collage%20style%20representing%20global%20tourism%20and%20adventure%20opportunities&width=1920&height=600&seq=tourshero&orientation=landscape"
            alt="Tours & Packages"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-navy-900/70 via-navy-900/50 to-navy-900/70"></div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl lg:text-6xl font-bold text-white mb-6"
          >
            Tours &amp; Packages
          </h1>
          <p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-xl text-white/90"
          >
            Find your perfect adventure from our curated collection of travel experiences
          </p>
        </div>
      </section>

      {/* Tours Section */}
      <section className="py-16 bg-[#FAF8F5]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8">
            {/* Filters Sidebar */}
            <div className="lg:w-72 flex-shrink-0">
              <div className="bg-white rounded-3xl p-6 shadow-lg sticky top-24">
                <h3 className="text-2xl font-bold text-navy-900 mb-6">Filter Tours</h3>
                
                {/* Category Filter */}
                <div className="mb-8">
                  <h4 className="text-sm font-semibold text-navy-900 mb-3 uppercase tracking-wide">
                    Category
                  </h4>
                  <div className="space-y-2">
                    {categories.map((category) => (
                      <button
                        key={category}
                        onClick={() => setSelectedCategory(category)}
                        className={`w-full text-left px-4 py-2.5 rounded-xl transition-all cursor-pointer whitespace-nowrap ${
                          selectedCategory === category
                            ? 'bg-gradient-to-r from-primary-600 to-accent-pink text-white font-semibold'
                            : 'bg-gray-50 text-gray-700 hover:bg-gray-100'
                        }`}
                      >
                        {category}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Price Range */}
                <div className="mb-8">
                  <h4 className="text-sm font-semibold text-navy-900 mb-3 uppercase tracking-wide">
                    Price Range
                  </h4>
                  <div className="space-y-4">
                    <input
                      type="range"
                      min="0"
                      max="5000"
                      step="100"
                      value={priceRange[1]}
                      onChange={(e) => setPriceRange([0, parseInt(e.target.value)])}
                      className="w-full h-2 bg-gradient-to-r from-primary-600 to-accent-pink rounded-lg appearance-none cursor-pointer"
                    />
                    <div className="flex items-center justify-between text-sm text-gray-600">
                      <span>${priceRange[0]}</span>
                      <span>${priceRange[1]}</span>
                    </div>
                  </div>
                </div>

                {/* Reset Button */}
                <button
                  onClick={() => {
                    setSelectedCategory('All');
                    setPriceRange([0, 5000]);
                  }}
                  className="w-full px-4 py-3 border-2 border-navy-900 text-navy-900 rounded-xl font-semibold hover:bg-navy-900 hover:text-white transition-all cursor-pointer whitespace-nowrap"
                >
                  Reset Filters
                </button>
              </div>
            </div>

            {/* Tours Grid */}
            <div className="flex-1">
              <div className="mb-6 flex items-center justify-between">
                <p className="text-gray-600">
                  Showing <strong className="text-navy-900">{filteredTours.length}</strong> tours
                </p>
              </div>

              <div className="grid md:grid-cols-2 gap-8">
                {filteredTours.map((tour, index) => (
                  <div
                    key={index}
                    className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
                  >
                    {/* Image */}
                    <div className="relative h-64 overflow-hidden rounded-t-3xl">
                      <img
                        src={tour.image}
                        alt={tour.title}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                      
                      {/* Category Badge */}
                      <div className="absolute top-4 left-4">
                        <span className="px-4 py-1.5 bg-accent-pink text-white text-xs font-semibold rounded-full">
                          {tour.category}
                        </span>
                      </div>
                    </div>

                    {/* Content */}
                    <div className="p-6">
                      <h3 className="text-2xl font-bold text-navy-900 mb-3 leading-tight">
                        {tour.title}
                      </h3>
                      
                      <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                        {tour.description}
                      </p>

                      {/* Highlights */}
                      <div className="flex flex-wrap gap-2 mb-4">
                        {tour.highlights.slice(0, 3).map((highlight, i) => (
                          <span key={i} className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">
                            {highlight}
                          </span>
                        ))}
                      </div>

                      {/* Details */}
                      <div className="flex items-center gap-4 mb-4 text-sm text-gray-500">
                        <div className="flex items-center gap-1.5">
                          <i className="ri-time-line"></i>
                          <span>{tour.duration}</span>
                        </div>
                        <div className="flex items-center gap-1.5">
                          <i className="ri-group-line"></i>
                          <span>{tour.groupSize}</span>
                        </div>
                      </div>

                      {/* Price & CTA */}
                      <div className="flex items-center justify-between mt-6">
                        <div>
                          <span className="text-sm text-gray-500">From</span>
                          <p className="text-2xl font-bold text-primary-600">${tour.price.toLocaleString()}</p>
                        </div>
                        <button 
                          onClick={() => handleBookNow(tour.title, tour.price)}
                          className="px-6 py-3 bg-gradient-to-r from-primary-600 to-accent-pink text-white rounded-full font-semibold hover:shadow-lg transition-all whitespace-nowrap cursor-pointer"
                        >
                          Book Now
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <BookingModal
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
        tourName={selectedTour.name}
        tourPrice={selectedTour.price}
      />
    </>
  );
}